/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanBaseResponse as SystemBooleanBaseResponse } from '../../models/System/boolean-base-response';

export interface V4PublicApplicationPersonalPingGet$Json$Params {
}

export function v4PublicApplicationPersonalPingGet$Json(http: HttpClient, rootUrl: string, params?: V4PublicApplicationPersonalPingGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemBooleanBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationPersonalPingGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemBooleanBaseResponse>;
    })
  );
}

v4PublicApplicationPersonalPingGet$Json.PATH = '/v4/public/application/personal/ping';
